import SelectAssetsField from './SelectAssetsField';

export default SelectAssetsField;